
      import Warning from './warning.vue'
      import type { App, Plugin } from 'vue'

      export const WarningPlugin: Plugin = {
        install(app: App) {
          app.component('Warning', Warning)
        },
      }
      export { Warning }
      